import {select, fork, take, put} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as sapActionTypes from '../sapActionTypes';

/**
 * Search SAP pickup location geolocation
 */
const searchSAPPickupLocationGeolocation = function* searchSAPPickupLocationGeolocation({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const arcGISRESTService = serviceManager.loadService('arcGISRESTService');

    const {searchQueryString, serviceAssignmentId} = payload;
    yield fork(
        fetchRequest,
        sapActionTypes.SEARCH_SAP_PICKUP_LOCATION_GEOLOCATION_REQUEST,
        arcGISRESTService.searchAddressSuggestions,
        {singleLine: searchQueryString, outFields: ['StAddr', 'Postal', 'City', 'Country', 'Region']},
    );

    const responseAction = yield take([
        sapActionTypes.SEARCH_SAP_PICKUP_LOCATION_GEOLOCATION_REQUEST_SUCCEEDED,
        sapActionTypes.SEARCH_SAP_PICKUP_LOCATION_GEOLOCATION_REQUEST_FAILED,
    ]);

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const {arcGISLocationCandidateDTOs} = response;

        yield put({
            type: sapActionTypes.SET_SAP_PICKUP_LOCATION_CANDIDATES,
            payload: {
                locationKey: 'pickupLocation',
                arcGISLocationCandidateDTOs,
                serviceAssignmentId,
                searchQueryString,
            },
        });
    }
};

export default searchSAPPickupLocationGeolocation;
